export const BUSINESS_ROW_KEYS = {
  MANAGE_MY_SITE: 'MANAGE_MY_SITE',
  HEALTH_CARE_PROVIDER: 'HEALTH_CARE_PROVIDER',
  SUPPORTED_LANGUAGES: 'SUPPORTED_LANGUAGES',
  LEADS_POOL: 'LEADS_POOL',
} as const;

export type BusinessRowKey =
  (typeof BUSINESS_ROW_KEYS)[keyof typeof BUSINESS_ROW_KEYS];

export const LEADS_POOL_OPT_IN_REQUIREMENTS = {
  requirementOneText: 'Achieve **Executive Director** or higher',
  requirementTwoText: 'Enroll at least 2 coach-converted Qualified New Clients',
  qualifiedNewClientDefinitionText:
    'A "Qualified New Client" is a client who has never previously placed an order with OPTAVIA and has 275+ Personal Qualifying Volume (PQV) during a Monthly Bonus Period.',
};
